export default "__VITE_ASSET__339aab90__"